// Every customer's operations account runs here: the control plane assumes its roles in this
// region, and nothing in the operations account is deployed anywhere else. Customer accounts
// carry their own main_region and are not covered by this.
export const OPERATIONS_ACCOUNT_REGION = 'eu-central-1';

export const AWS_REGIONS = [
  { value: 'us-east-1', label: 'us-east-1 (US East - N. Virginia)' },
  { value: 'us-east-2', label: 'us-east-2 (US East - Ohio)' },
  { value: 'us-west-1', label: 'us-west-1 (US West - N. California)' },
  { value: 'us-west-2', label: 'us-west-2 (US West - Oregon)' },
  { value: 'eu-central-1', label: 'eu-central-1 (Europe - Frankfurt)' },
  { value: 'eu-west-1', label: 'eu-west-1 (Europe - Ireland)' },
  { value: 'eu-west-2', label: 'eu-west-2 (Europe - London)' },
  { value: 'eu-north-1', label: 'eu-north-1 (Europe - Stockholm)' },
  { value: 'ap-southeast-1', label: 'ap-southeast-1 (Asia Pacific - Singapore)' },
  { value: 'ap-southeast-2', label: 'ap-southeast-2 (Asia Pacific - Sydney)' },
];
